var windowHeight = $(window).height();

$(window).on('load scroll', function () {
    let scrollPos = $(window).scrollTop();

    $('.js-anim__trigger').each(function () {
        let elementTop = $(this).offset().top;

        if (scrollPos >= elementTop - windowHeight + 100) {
            $(this).addClass('is-act');
        }
    });
});
